export var FILTER_EMPTY = {
  conditions: []
};
export var SCHEMA_EMPTY = {
  conditions: []
};